module.exports = __webpack_public_path__ + "img/6dbdc10.png";